module.exports = __webpack_public_path__ + "assets/img/header_back_r.8c02c1ef.svg";